import {Storage} from './storage';

export const LANGUAGE_STORAGE_KEY = 'lang';
export const BROWSER_DEFAULT_LANGUAGE = 'Browser Default';

// Normalize language codes: convert underscores to hyphens to comply with BCP 47 standard (required by ICU)
export const normalizeLanguageCode = (language: string) =>
    language.replace('_', '-');

export const isBrowserDefaultLanguage = (language?: string | null) =>
    language === BROWSER_DEFAULT_LANGUAGE;

export const getBrowserLanguagePreference = (): string => {
    if (typeof navigator !== 'undefined') {
        if (navigator.languages && navigator.languages.length > 0) {
            return navigator.languages[0];
        }

        if (navigator.language) {
            return navigator.language;
        }
    }

    return 'en';
};

export const getBrowserAcceptLanguageHeader = (): string => {
    if (typeof navigator !== 'undefined') {
        if (navigator.languages && navigator.languages.length > 0) {
            return navigator.languages.join(',');
        }

        if (navigator.language) {
            return navigator.language;
        }
    }

    return getBrowserLanguagePreference();
};

export const setLanguagePreference = (language: string) => {
    if (!language || isBrowserDefaultLanguage(language)) {
        Storage.removeData(LANGUAGE_STORAGE_KEY);
        return;
    }

    Storage.storeData(LANGUAGE_STORAGE_KEY, language);
};
